import React, { useEffect, lazy, Suspense } from "react";
import Header from "./Header/Header";
import alanBtn from "@alan-ai/alan-sdk-web";
import { useArticle } from "../Contexts/ArticleContext";
import { useActiveArticle } from "../Contexts/ActiveArticleContext";
import { useCurrentPage } from "../Contexts/CurrentPageContext";
import NewsCards from "./Content/NewsCards/NewsCards";
import parseNumber from "words-to-numbers";
import HOD from "./HOD/HOD";
import { CircularProgress } from "@material-ui/core";

const CategoryCards = lazy(() => import("./Category/CategoryCards"));
const Footer = lazy(() => import("./Footer/Footer"));

const App = () => {
  const key = process.env.REACT_APP_ALAN_KEY;
  const [_, setArticles] = useArticle();
  const [acticeArticle, setActiveArticle] = useActiveArticle();
  const [currentPage, setCurrentPage] = useCurrentPage();

  useEffect(() => {
    alanBtn({
      key: key,
      onCommand: ({ command, articles, number }) => {
        if (command === "newHeadLines") {
          setCurrentPage(1);
          setActiveArticle(-1);
          setArticles(articles);
        } else if (command === "highlightNews") {
          setActiveArticle((prev) => {
            if (prev > 0 && (prev + 1) % 6 === 0) {
              setCurrentPage((prev) => prev + 1);
            }
            return prev + 1;
          });
        } else if (command === "openArticle") {
          const articleNumber = Number.isInteger(number)
            ? number
            : parseNumber(number);

          const article = articles[articleNumber - 1];

          if (article) {
            window.open(article.url, "_blank");
          }
        }
      },
    });
  }, []);

  return (
    <div>
      <Header />
      <NewsCards />
      <HOD />
      <Suspense fallback={<CircularProgress />}>
        <CategoryCards />
        <Footer />
      </Suspense>
    </div>
  );
};

export default App;
